import { useApolloClient } from "@apollo/client";
import React from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { Subheader } from "../../../components";
import { AlertContext, AuthContext, BackdropContext } from "../../../contexts";
import { PROPERTY_DETAILS_BY_POPERTY_ID } from "../../../graphql/queries";
import { accessCheckRender, AlertProps, getRoutePermissionNew } from "../../../utils";
import { PropertyDetails } from './propertyView/propertydetails';
import { withNamespaces } from "react-i18next";

const AccessGatesPropertyView = ({
      t
}) => {

      const history = useHistory()
      const client = useApolloClient()
      const search = useLocation().search
      const propertyID = new URLSearchParams(search).get("propertyID")

      // useContext
      const alert = React.useContext(AlertContext)
      const backdrop = React.useContext(BackdropContext)
      const auth = React.useContext(AuthContext)

      // useState
      const [data, setData] = React.useState([])
      const [permission, setPermission] = React.useState({})

      // use effect to get permission
      React.useEffect(() => {
            const perm = getRoutePermissionNew(auth)
            if (perm) {
                  setPermission(perm)
                  if (perm?.read) {
                        if (propertyID) { getPropertyByID() }
                  }
            }
            // eslint-disable-next-line
      }, [auth, propertyID]);

      // Function to get property details
      const getPropertyByID = () => {
            backdrop.setBackDrop({ ...backdrop, open: true, message: t("Loading...") })
            client.query({
                  query: PROPERTY_DETAILS_BY_POPERTY_ID, fetchPolicy: 'network-only',
                  variables: { propertyID }
            }).then((r) => {
                  setData(r?.data)
                  backdrop.setBackDrop({ ...backdrop, open: false, message: "" })
            }).catch((err) => {
                  backdrop.setBackDrop({ ...backdrop, open: false, message: "" })
                  alert.setSnack({
                        ...alert, open: true,
                        severity: AlertProps.severity.error, msg: t("Some Thing Went Wrong")
                  })
            })
      }

      const render = () => {
            return <>
                  <Subheader title={data?.property?.[0]?.name} goBack={() => history.goBack(-1)}
                        select isReadOnly={true} value={data?.property?.[0]?.company} />
                  <PropertyDetails t={t} permission={permission} data={data?.property?.[0]} assets={data?.asset} />
            </>
      }

      return (
            <div >
                  {accessCheckRender(render, permission)}
            </div >
      )

}
export default withNamespaces("accessGates")(AccessGatesPropertyView);
